<style lang="scss" scoped>
h4 {
  margin-bottom: 16px;
  font-weight: bold;
}

.form-field {
  margin-bottom: 20px;
  clear: both;
}

.create_form {
  .require {
    color: #ff1a1a;
  }
}

.employees {
  margin-bottom: 50px;
}

.employees-form.button {
  margin-top: 40px;
  padding: 0px;
}

.save-info {
  background: #b4daf3;
  font-weight: 600;
  padding: 7px 70px;
  color: #0d2e48;
  margin-right: 20px;
  border: 2px solid #b4daf3;
}

.cancel-employee {
  padding: 7px 45px;
  font-weight: 600;
  background: #f6f6f6;
  border: 2px solid #0d2e48;
  color: #0d2e48;
  max-width: 300px;
}

.employees.container {
  margin-bottom: 40px;

  label {
    font-weight: 600;
    display: inline-block;
    width: 33%;
  }

  .form-group {
    display: inline-block;
    width: 66%;
    margin-bottom: 5px;
  }

  .form-control {
    display: inline-block;
    width: 66%;
    margin-bottom: 0px;
  }

  .form-control-file {
    display: inline-block;
    width: 66%;
    float: right;
    margin: 0px 0px 15px;
  }

  .image-avartar {
    margin-bottom: 15px;
  }

  .error.image {
    color: #ff1a1a;
    width: 100%;
    margin-bottom: 0px;
    display: inline-block;
  }

  .form-field.avatar {
    margin-bottom: 34px;
  }
}

.employees .required {
  color: #ff1a1a;
  margin-left: 34%;
  margin-top: -15px;
}

.datepicker-input {
  display: flex;
}

.date-picker {
  width: calc(100% - 175px);
}

.datepicker-input {
  display: flex;
}

.date-picker {
  width: calc(100% - 175px);
}

@media screen and (max-width: 1200px) {
  .container-fluid {
    .employees.container {
      .form-group {
        display: inline-block;
        width: 100%;
      }

      .form-control {
        width: 100%;
      }
    }

    .employees .required {
      margin-left: 0%;
    }

    .employees.container label {
      width: 100%;
    }
  }
}

@media screen and (max-width: 767px) {
  .employees .save-info {
    margin-right: 0px;
  }
  .save-info {
    margin-bottom: 0.4rem;
    width: 100%;
  }

  .cancel-employee {
    width: 100%;
    max-width: 100%;
  }

  .employees-form {
    padding: 0px;
  }
  .employees-form-mobile {
    margin-bottom: 1rem;
  }
  .employees.container {
    padding: 0px;
    .form-field.avatar {
      margin-bottom: 0.5rem;
      display: flex;
      flex-direction: column;
    }
  }
  .employees.container .form-control-file {
    float: left;
    width: 100% !important;
    overflow: hidden;
  }
  .br-mobile-none {
    display: none;
  }
  .employees-form.button.button-mobile {
    margin-top: 0.5rem;
  }
  .form-field {
    margin-bottom: 1rem;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employees.container {
    max-width: 100%;
    padding: 0;
    .form-group {
      margin-bottom: 0;
    }
    .form-control-file {
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.skill-sheet-employee {
  .employees-form {
    padding: 0 ;
    margin-bottom: 30px;
    .title-header {
      font-weight: 600;
      font-size: 18px;
    }
    .table {
      border-color: rgba(0, 0, 21, 0.125);

      .description-rank {
        vertical-align: middle;
        border-color: rgba(0, 0, 21, 0.125);
      }
    }
  }

  .body {
    .create-form {
      .card-body {
        padding: 1.25rem 0 1.25rem 1.25rem;
      }
      .nav {
        padding: 20px 0 0 0;
      }
      .skill-btn {
        margin-top: 20px;
        text-align: center;

        .save-info {
          background: #b4daf3;
          font-weight: 600;
          padding: 7px 70px;
          color: #0d2e48;
          margin-right: 20px;
          border: 2px solid #b4daf3;
        }

        .cancel-info {
          padding: 7px 45px;
          font-weight: 600;
          background: #f6f6f6;
          border: 2px solid #0d2e48;
          color: #0d2e48;
          max-width: 300px;
        }
      }

      .skill-name {
        align-self: center;
        font-weight: bold;
      }

      .skill-rank {
        align-self: center;
      }

      .skill-experience {
        align-items: center;

        .delete-btn {
          color: red;
          margin-left: 20px;
        }

        .experience-time {
          margin-bottom: 0;
        }
      }

      .skill-description {
        margin-right: 15px;
        margin-left: 15px;
      }

      .skill-type {
        font-weight: bold;
        width: 25%;

        .toggle-list-skill {
          margin-left: 30px;
        }
      }
      .skill-level {
        width: 60%;
        display: flex;
        .skill-level__left {
          width: 25%;
        }
        .skill-level__right {
          width: 75%;
          display: flex;
          justify-content: space-around;
        }
      }
      .skill-experience {
        width: 20%;
        label {
          margin-left: 38px;
        }
      }
      .title-form-header {
        font-weight: bold;
        display: flex;
      }
    }
  }
}
.menuSkill {
  display: none;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .skill-sheet-employee .employees-form {
    padding: 0 1.5rem;
  }
  .menuSkill {
    display: block !important;
  }
  .skill-type {
    display: none;
  }
  .body {
    margin-top: 7px;
    overflow: scroll;
    padding: 0;
  }
  .create-form {
    overflow: scroll;
    min-width: 900px;
  }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .skill-sheet-employee {
    .body {
      .create-form {
        .card-body {
          padding: 0.25rem 0 !important;
        }
        .skill-level {
          width: 75% !important;
          display: flex;
          .skill-level__left {
            width: 23%;
            margin-left: 50px;
          }
          .skill-level__right {
            width: 61%;
            display: flex;
            justify-content: space-between !important;
          }
        }
      }
    }
  }
  .ml-tablet-140 {
    margin-left: 140px;
  }
}
@media screen and(max-width: 767px) {
  .body {
    margin-top: 7px;
    overflow: scroll;
    padding: 0;
  }
  .create-form {
    overflow: scroll;
    min-width: 900px;
  }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .menuSkill {
    display: block !important;
  }
}
</style>

<template>
  <CContainer class="employees">
    <ValidationObserver ref="formEmployee" v-slot="{ handleSubmit }">
      <CForm class="create_form" @submit.prevent="handleSubmit(submitEmployee)">
        <CRow>
          <CCol md="6" sm="12" class="employees-form employees-form-mobile">
            <CCol md="12">
              <h4>{{ $t("label.personal_information") }}</h4>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.id_code") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|numeric|max:4|min_value:1"
                v-slot="{ errors }"
                :name="$t('label.id_code')"
              >
                <CInput type="text" v-model="form.id" maxlength="4" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field" v-if="!idEmployee">
              <label>
                {{ $t("label.email") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                :name="$t('label.email')"
              >
                <CInput type="email" v-model="form.email" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.full_name") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|min:6|max:64"
                v-slot="{ errors }"
                :name="$t('label.full_name')"
              >
                <CInput v-model="form.name" />

                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.birthday") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.birthday')"
              >
                <DatePickerForm
                  :propsDate="form.birthday"
                  v-on:emitDate="birthDay"
                  v-model="form.birthday"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.native_country") }}</label>
              <CInput v-model="form.address" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.address") }}</label>
              <CInput v-model="form.current_address" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.university") }}</label>
              <CInput v-model="form.university_name" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.form_of_work") }}</label>
              <select class="form-control" v-model="form.work_type">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) of workType"
                  :key="index"
                  :value="index"
                >
                  {{ option }}
                </option>
              </select>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.shift_of_work") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.shift_of_work')"
              >
                <select class="form-control" v-model="form.work_shift">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in workShift"
                    :key="index"
                    :value="option.id"
                    >{{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.shift_of_work_active_from") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.shift_of_work_active_from')"
              >
                <DatePickerForm
                    :propsDate="form.work_shift_active_from"
                    v-on:emitDate="workShiftActiveFrom"
                    v-model="form.work_shift_active_from"
                    :minDate="initialWorkShiftActiveFrom"
                  />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

          </CCol>

          <CCol md="6" sm="12" class="employees-form">
            <CCol md="12">
              <h4>{{ $t("label.information_business") }}</h4>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.time_start") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.time_start')"
              >
                <DatePickerForm
                  :propsDate="form.join_date"
                  v-on:emitDate="joinDate"
                  v-model="form.join_date"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.member_companies") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.member_companies')"
              >
                <select class="form-control" v-model="form.company_code">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, key, index) in companies"
                    :key="index"
                    :value="key"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.office") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.office')"
              >
                <select class="form-control" v-model="form.job_title_code">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in jobTitle"
                    :key="index"
                    :value="option.code"
                    >{{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.foot") }}
              </label>
              <select class="form-control" v-model="form.foot">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) in foots"
                  :key="index"
                  :value="option.code"
                  >{{ option.name }}
                </option>
              </select>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.division") }}
              </label>
              <select class="form-control" v-model="form.department_code">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) in divisions"
                  :key="index"
                  :value="option.code"
                  >{{ option.name }}
                </option>
              </select>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.position") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('label.position')"
              >
                <select class="form-control" v-model="form.position_id">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in positions"
                    :key="index"
                    :value="option.id"
                    >{{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.level") }}</label>
              <select class="form-control" v-model="form.level">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) in jobLevel"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}</option
                >
              </select>
            </CCol>
            <CCol md="12" class="form-field">
              <label>{{ $t("label.Japanese") }}</label>
              <select class="form-control" v-model="form.japanese_level">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) in japaneseLevel"
                  :key="index"
                  :value="option.id"
                  >{{ option.name }}</option
                >
              </select>
            </CCol>
          </CCol>
        </CRow>
        <br class="br-mobile-none" />
        <br class="br-mobile-none" />
        <CRow>
          <CCol md="6" sm="12" class="employees-form">
            <CCol md="12" class="other-infomation">
              <h4>{{ $t("label.other_infomation") }}</h4>
            </CCol>

            <CCol md="12" class="form-field avatar">
              <label>{{ $t("label.personal_photo") }}</label>
              <img
                v-if="image_employee"
                class="image-avartar"
                :src="image_employee"
                width="100"
                height="100"
              />
              <img
                v-else
                class="image-avartar"
                src="@/assets/no-image-available.jpg"
                width="100"
                height="100"
              />
              <ValidationProvider
                rules="image|size:2000"
                v-slot="{ errors }"
                :name="$t('label.personal_photo')"
              >
                <input
                  type="file"
                  v-on:change="onImageChange"
                  class="form-control-file"
                  id="fileImage"
                />
                <span v-if="!isImage" class="error image required">{{
                  errorFileMessage
                }}</span>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.gender") }}</label>
              <select class="form-control" v-model="form.gender">
                <option value="">{{ $t("employee.select_option") }}</option>
                <option
                  v-for="(option, index) in gender"
                  :key="index"
                  :value="option"
                >
                  {{ $t("commons.label_gender_name_" + option) }}
                </option>
              </select>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.nationality") }}</label>
              <CInput v-model="form.nationality" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.nation") }}</label>
              <CInput v-model="form.nation" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.phone_number") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|numeric|min:9|max:14"
                v-slot="{ errors }"
                :name="$t('label.phone_number')"
              >
                <CInput type="text" v-model="form.phone" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.phone_number_family") }}
              </label>
              <ValidationProvider
                rules="numeric|min:9|max:14"
                v-slot="{ errors }"
                :name="$t('label.phone_number_family')"
              >
                <CInput type="text" v-model="form.phone_family" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CCol>

          <CCol md="6" sm="12" class="employees-form">
            <CCol md="12">
              <br class="br-mobile-none" />
              <br class="br-mobile-none" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>
                {{ $t("label.id_card_pasport") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                :rules="{
                  required: true,
                  regex: /^[a-zA-Z0-9]+$/,
                  min: 6,
                  max: 32
                }"
                v-slot="{ errors }"
                :name="$t('label.id_card_pasport')"
              >
                <CInput type="text" v-model="form.identity_number" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.date_provide") }}</label>
              <DatePickerForm
                :propsDate="form.identity_card_date"
                v-on:emitDate="identityCardDate"
                v-model="form.identity_card_date"
              />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.place_provide") }}</label>
              <CInput v-model="form.identity_card_place" />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.visa") }}</label>
              <ValidationProvider
                rules="numeric|min:6|max:32"
                v-slot="{ errors }"
                :name="$t('label.visa_card_number')"
              >
                <CInput type="text" v-model="form.visa_card_number" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.expiry_date_visa") }}</label>
              <DatePickerForm
                :propsDate="form.visa_date_period"
                v-on:emitDate="visaDatePeriod"
                v-model="form.visa_date_period"
              />
            </CCol>

            <CCol md="12" class="form-field">
              <label>{{ $t("label.link_facebook") }}</label>
              <ValidationProvider
                :rules="{
                  regex: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
                }"
                v-slot="{ errors }"
                :name="$t('label.link_facebook')"
              >
                <CInput v-model="form.link_facebook" />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CCol>
        </CRow>
        <CRow class="skill-sheet-employee">
          <CCol md="12" sm="12" class="employees-form">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol md="12 table-mobile">
                    <label class="title-header">{{
                      $t("skill_sheet.label_title")
                    }}</label>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12 table-mobile">
                    <table border class="table">
                      <tr>
                        <td rowspan="6" class="description-rank">
                          {{ $t("skill_sheet.label_description_of_ranking") }}
                        </td>
                        <td>0</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank0") }}
                        </td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank1") }}
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank2") }}
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank3") }}
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank4") }}
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>
                          {{ $t("skill_sheet.label_description_of_rank5") }}
                        </td>
                      </tr>
                    </table>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody class="body">
                <span class="menuSkill" @click.prevent="showMenuSkill"
                  ><CIcon size="2xl" name="cil-chevron-right"
                /></span>
                <CRow class="create-form">
                  <CRow
                    :class="{
                      'ml-mobile-140': menuStatus,
                      'ml-tablet-140': menuStatus
                    }"
                  >
                    <CCol md="12" class="title-form-header">
                      <div class="skill-type">
                        {{ $t("skill_sheet.label_title_type_skill") }}
                      </div>
                      <div class="skill-level">
                        <div class="skill-level__left">
                          {{ $t("skill_sheet.label_title_skill") }}
                        </div>
                        <div class="skill-level__right">
                          <label class="rank-title rank0">{{
                            $t("skill_sheet.label_rank_0")
                          }}</label>
                          <label class="rank-title rank1">{{
                            $t("skill_sheet.label_rank_1")
                          }}</label>
                          <label class="rank-title rank2">{{
                            $t("skill_sheet.label_rank_2")
                          }}</label>
                          <label class="rank-title rank3">{{
                            $t("skill_sheet.label_rank_3")
                          }}</label>
                          <label class="rank-title rank4">{{
                            $t("skill_sheet.label_rank_4")
                          }}</label>
                          <label class="rank-title rank5">{{
                            $t("skill_sheet.label_rank_5")
                          }}</label>
                        </div>
                      </div>
                      <div class="skill-experience">
                        <label class="time">{{
                          $t("skill_sheet.label_experience_time")
                        }}</label>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol md="12">
                      <b-tabs
                        pills
                        card
                        vertical
                        :nav-wrapper-class="
                          menuStatus === true
                            ? 'mobile-screen-show-tab'
                            : 'tab-skillsheet'
                        "
                      >
                        <b-tab
                          title-item-class="mytab"
                          v-for="(skillNames, key) in skillSheet.skillName"
                          :key="key"
                          :title="skillSheet.skillType[key]"
                        >
                          <b-card-text>
                            <div
                              href="#"
                              class="d-flex list-group-item skill-description"
                              v-for="(skill, index) in skillNames"
                              :key="index"
                              md="12"
                            >
                              <CCol class="skill-name" md="2">
                                <label class="skill-name">{{ skill }}</label>
                              </CCol>
                              <CCol class="skill-rank" md="7">
                                <div class="d-flex justify-content-around">
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="0"
                                    />
                                  </label>
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="1"
                                    />
                                  </label>
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="2"
                                    />
                                  </label>
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="3"
                                    />
                                  </label>
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="4"
                                    />
                                  </label>
                                  <label class="form-check-inline rank-option">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      v-model="form.skill[skill]"
                                      value="5"
                                    />
                                  </label>
                                </div>
                              </CCol>
                              <CCol class="skill-experience d-flex" md="3">
                                <CInput
                                  class="experience-time"
                                  type="text"
                                  v-model="form.experience[skill]"
                                ></CInput>
                              </CCol>
                            </div>
                          </b-card-text>
                        </b-tab>
                      </b-tabs>
                    </CCol>
                  </CRow>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>

        <CCol md="12" sm="12" class="employees-form button button-mobile">
          <CCol md="12" class="employees-form">
            <CButton type="submit" class="save-info"
              >{{ $t("label.save_infomation") }}
            </CButton>
            <CButton
              v-if="!idEmployee"
              class="cancel-employee"
              type="button"
              @click="cancel"
              >{{ $t("label.cancel_employee") }}
            </CButton>
            <CButton
              v-if="idEmployee"
              class="cancel-employee"
              type="button"
              @click="cancel"
              >{{ $t("label.cancel_update_employee") }}
            </CButton>
          </CCol>
        </CCol>
      </CForm>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "sweetalert2/src/sweetalert2.scss";
import DatePickerForm from "../Common/DatePickerForm";
import SabbaticalStatistical from "../../views/SabbaticalLog/SabbaticalLeaveStatistical.vue"

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerForm,
    SabbaticalStatistical
  },

  props: {
    jobTitle: {
      type: Array,
      default: () => []
    },
    positions: {
      type: Array,
      default: () => []
    },
    jobLevel: {
      type: Array,
      default: () => []
    },
    companies: {
      type: [Array, Object],
      default: () => {}
    },
    gender: {
      type: Array,
      default: () => []
    },
    japaneseLevel: {
      type: Array,
      default: () => []
    },
    workType: {
      type: [Array, Object],
      default: () => []
    },
    workShift: {
      type: Array,
      default: () => []
    },
    foots: {
      type: Array,
      default: () => []
    },
    divisions: {
      type: Array,
      default: () => []
    },
    informationEmployee: {
      type: Object,
      default: () => {}
    },
    skillSheet: {
      type: Object,
      default: () => {}
    },
    experience: {
      type: Array,
      default: () => []
    },
    menuStatus: {
      type: Boolean,
      default: () => false
    },
    skill: {
      type: Array,
      default: () => []
    },
    selectedSkill: {
      type: Array,
      default: () => []
    },
    selectedExperience: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      errorFileMessage: "",
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG"
      ],
      isImage: true,
      image_employee: "",
      idEmployee: "",
      initialWorkShiftActiveFrom: null,
      form: {
        id: "",
        name: "",
        birthday: "",
        birthdayFormat: "",
        current_address: "",
        address: "",
        university_name: "",
        work_type: "",
        work_shift: "",
        work_shift_active_from: "",
        join_date: "",
        company_code: "",
        job_title_code: "",
        foot: "",
        department_code: "",
        position_id: "",
        level: "",
        japanese_level: "",
        image_url: "",
        gender: "",
        nationality: "",
        nation: "",
        phone: "",
        phone_family: "",
        identity_number: "",
        identity_card_date: "",
        identity_card_place: "",
        visa_card_number: "",
        visa_date_period: "",
        link_facebook: "",
        email: "",
        skill: {},
        experience: {}
      }
    };
  },

  async created() {
    this.idEmployee = this.$route.params.id;
    this.form.join_date = Intl.DateTimeFormat("en-GB").format(new Date());
    this.form.work_shift_active_from = Intl.DateTimeFormat("en-GB").format(new Date());
    this.initialWorkShiftActiveFrom = new Intl.DateTimeFormat("en-GB").format(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  },

  methods: {
    birthDay(data) {
      this.form.birthday = data;
    },

    joinDate(data) {
      this.form.join_date = data;
    },

    identityCardDate(data) {
      this.form.identity_card_date = data;
    },

    visaDatePeriod(data) {
      this.form.visa_date_period = data;
    },

    workShiftActiveFrom(data) {
      this.form.work_shift_active_from = data;
    },

    submitEmployee() {
      if (this.errorFileMessage) return;
      const formData = new FormData();
      for (let key in this.form) {
        if (key === "department_code") {
          if (this.form.department_code === "" && this.form.foot !== "") {
            formData.append("department_code", this.form.foot);
          } else {
            formData.append("department_code", this.form.department_code);
          }
        } else if (key === "image_url") {
          if (this.form.image_url !== null && this.form.image_url !== "") {
            formData.append("file_url", this.form[key]);
          }
        } else if (key === "skill") {
          if (this.form.skill !== null && this.form.skill !== "") {
            formData.append("skill", JSON.stringify(this.form.skill));
          }
        } else if (key === "experience") {
          if (this.form.experience !== null && this.form.experience !== "") {
            formData.append("experience", JSON.stringify(this.form.experience));
          }
        } else {
          formData.append(key, this.form[key]);
        }
      }
      

      if (this.idEmployee) {
        formData.append("old_id", this.idEmployee);
      }

      this.$emit("submitCreateEmployee", formData);
      this.$emit("submitUpdateEmployee", formData);
    },

    // change avartar
    onImageChange(e) {
      let file = e.target.files[0];
      if (
        e.target.files[0] &&
        !this.imageType.includes(e.target.files[0].type)
      ) {
        this.isImage = false;
        this.form.image_url = "";
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      // check size file
      if (e.target.files[0] && e.target.files[0].size > 2000000) {
        this.isImage = false;
        this.errorFileMessage = this.$t("error.img_max");
        return;
      }
      //display image is choosen
      if (file !== undefined) {
        this.image_employee = URL.createObjectURL(file);
      }
      this.errorFileMessage = null;
      this.isImage = true;
      this.form.image_url = e.target.files[0];
    },

    cancel() {
      let titleHeader = "";
      if (this.idEmployee) {
        titleHeader = this.$t("popup.employee.label_popup_header_update");
      } else {
        titleHeader = this.$t("popup.employee.label_popup_header_create");
      }
      this.$confirm(
        titleHeader,
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/employees" });
        }
      });
    }
  },
  watch: {
    informationEmployee(val) {
      if (!val.id) return this.form;
      for (let key in val) {
        if (key === "image_url") {
          this.image_employee = val[key];
        } else if (val[key] !== null) {
          this.form[key] = val[key];
        }
      }
      if (val.department_code) {
        if (val.department.parent_code === null) {
          this.form.foot = val.department.code;
          this.form.department_code = "";
        } else {
          this.form.department_code = val.department.code;
          this.form.foot = val.department.parent_code;
        }
      }
    }
  }
};
</script>
